var map = {
	"./Certification/BSMI_01.jpg": "8f99",
	"./Certification/BSMI_02.jpg": "3d5f",
	"./Certification/BSMI_03.jpg": "b0f2",
	"./Certification/BSMI_04.jpg": "273e",
	"./Certification/Renwu/ISO14001_Renwu_2.jpg": "8079",
	"./Certification/Renwu/ISO14001_Renwu_mobile.jpg": "29a2",
	"./Certification/Renwu/ISO9001_Renwu_1.jpg": "177a",
	"./Certification/Renwu/ISO9001_Renwu__mobile.jpg": "9970",
	"./Certification/Renwu/OHSAS18001_Renwu_3.jpg": "3474",
	"./Certification/Renwu/OHSAS18001_Renwu_mobile.jpg": "d314",
	"./Certification/Renwu/TAF_Renwu_4.jpg": "95f3",
	"./Certification/Renwu/TAF_Renwu_mobile.jpg": "d997",
	"./Certification/Shulin/ISO14001_Shulin.jpg": "f28a",
	"./Certification/Shulin/ISO9001_Shulin.jpg": "f143",
	"./Certification/Shulin/OHSAS18001_Shulin.jpg": "a304",
	"./Certification/Shulin/TAF_Shulin.jpg": "e1e8",
	"./Certification/quality_page top img_desktop.jpg": "7456",
	"./Certification/quality_page top img_mobile.jpg": "d0d8",
	"./Certification/semi_green_info_01_logo.png": "e274",
	"./Contact/contact_page top img_desktop.jpg": "3887",
	"./Contact/contact_page top img_mobile.jpg": "ddf9",
	"./Products/Cooler_Paint/cooler page top img_desktop.jpg": "ad99",
	"./Products/Cooler_Paint/cooler page top img_mobile.jpg": "ff5b",
	"./Products/Cooler_Paint/products application_cooler1.jpg": "5c49",
	"./Products/Cooler_Paint/products application_cooler2.jpg": "ba07",
	"./Products/Cooler_Paint/products application_cooler3.jpg": "a670",
	"./Products/Cooler_Paint/products application_cooler4.jpg": "9149",
	"./Products/Cooler_Paint/products discription_cooler1.jpg": "6be6",
	"./Products/Cooler_Paint/products discription_cooler2.jpg": "49c8",
	"./Products/Cooler_Paint/products discription_cooler3.jpg": "6485",
	"./Products/PU_Waterproof/PU page top img_desktop.jpg": "35e6",
	"./Products/PU_Waterproof/PU page top img_mobile.jpg": "e1b6",
	"./Products/PU_Waterproof/products application_pu1.jpg": "3290",
	"./Products/PU_Waterproof/products application_pu2.jpg": "fa68",
	"./Products/PU_Waterproof/products application_pu3.jpg": "2834",
	"./Products/PU_Waterproof/products application_pu4.jpg": "28bc",
	"./Products/PU_Waterproof/products discription_pu1.jpg": "37ed",
	"./Products/PU_Waterproof/products discription_pu2.jpg": "65d9",
	"./Products/PU_Waterproof/products discription_pu3.jpg": "c65f",
	"./Products/green products card_01.jpg": "6199",
	"./Products/green products card_02.jpg": "944e",
	"./Products/green products card_03.jpg": "34d8",
	"./Products/green products card_04.jpg": "c052",
	"./Products/pool/pool page top img_desktop.jpg": "1060",
	"./Products/pool/pool page top img_mobile.jpg": "f644",
	"./Products/pool/products application_pool1.jpg": "70ce",
	"./Products/pool/products application_pool2.jpg": "4ad1",
	"./Products/pool/products application_pool3.jpg": "b3c6",
	"./Products/pool/products application_pool4.jpg": "a4bf",
	"./Products/pool/products discription_pool1.jpg": "2ddb",
	"./Products/pool/products discription_pool2.jpg": "767c",
	"./Products/pool/products discription_pool3.jpg": "f90a",
	"./Products/pool/products discription_pool4.jpg": "7330",
	"./Products/products background img_bllue.jpg": "9506",
	"./Products/products background img_purple.jpg": "0d14",
	"./Products/products_cooler.jpg": "162f",
	"./Products/products_cooler_mobile.jpg": "a6b9",
	"./Products/products_green enegry_mobile.jpg": "3c26",
	"./Products/products_green_enegry.jpg": "2f7d",
	"./Products/products_normal.jpg": "c659",
	"./Products/products_normal_mobile.jpg": "e927",
	"./Products/products_page top img_mobile.jpg": "0998",
	"./Products/products_pageTop_desktop.jpg": "a86f",
	"./Products/products_pool.jpg": "f530",
	"./Products/products_pool_mobile.jpg": "25a2",
	"./Products/products_pu.jpg": "7931",
	"./Products/products_pu_mobile.jpg": "4356",
	"./Products/products_redmud.jpg": "dfc8",
	"./Products/products_redmud_mobile.jpg": "fa23",
	"./Products/products_roof.jpg": "f48c",
	"./Products/products_roof_mobile.jpg": "6aba",
	"./Products/products_tunnel.jpg": "7c4b",
	"./Products/products_tunnel_mobile.jpg": "2fb8",
	"./Products/red_Tape/products application_redmud1.jpg": "e26e",
	"./Products/red_Tape/products application_redmud2.jpg": "6724",
	"./Products/red_Tape/products application_redmud3.jpg": "2c56",
	"./Products/red_Tape/products application_redmud4.jpg": "dd71",
	"./Products/red_Tape/products discription_redmud1.jpg": "023b",
	"./Products/red_Tape/products discription_redmud2.jpg": "91be",
	"./Products/red_Tape/products discription_redmud3.jpg": "72ce",
	"./Products/red_Tape/redmud page top img_desktop.jpg": "e4f3",
	"./Products/red_Tape/redmud page top img_mobile.jpg": "011b",
	"./Products/roof_Waterproof/products application_rooftop1.jpg": "9977",
	"./Products/roof_Waterproof/products application_rooftop2.jpg": "f986",
	"./Products/roof_Waterproof/products application_rooftop3.jpg": "cb4d",
	"./Products/roof_Waterproof/products application_rooftop4.jpg": "241b",
	"./Products/roof_Waterproof/products discription_rooftop1.jpg": "ca4c",
	"./Products/roof_Waterproof/products discription_rooftop2.jpg": "bbd9",
	"./Products/roof_Waterproof/products discription_rooftop3.jpg": "f392",
	"./Products/roof_Waterproof/rooftop page top img_desktop.jpg": "7843",
	"./Products/roof_Waterproof/rooftop page top img_mobile.jpg": "9d78",
	"./Products/tough_Waterproof/normal page top img_desktop.jpg": "0cfb2",
	"./Products/tough_Waterproof/normal page top img_mobile.jpg": "b4da",
	"./Products/tough_Waterproof/products application_normal1.jpg": "ef8f",
	"./Products/tough_Waterproof/products application_normal2.jpg": "6f5f",
	"./Products/tough_Waterproof/products application_normal3.jpg": "77ae",
	"./Products/tough_Waterproof/products application_normal4.jpg": "a55b",
	"./Products/tough_Waterproof/products discription_normal1.jpg": "a8a8",
	"./Products/tough_Waterproof/products discription_normal2.jpg": "21fc",
	"./Products/tough_Waterproof/products discription_normal3.jpg": "1ef4",
	"./Products/tunnel_Waterproof/products application_tunnel1.jpg": "5499",
	"./Products/tunnel_Waterproof/products application_tunnel2.jpg": "3c65",
	"./Products/tunnel_Waterproof/products application_tunnel3.jpg": "d850",
	"./Products/tunnel_Waterproof/products application_tunnel4.jpg": "b905",
	"./Products/tunnel_Waterproof/products discription_tunnel1.jpg": "6b57",
	"./Products/tunnel_Waterproof/products discription_tunnel2.jpg": "3423",
	"./Products/tunnel_Waterproof/tunnel page top img_desktop.jpg": "02ef",
	"./Products/tunnel_Waterproof/tunnel page top img_mobile.jpg": "6a18",
	"./QA_Page/FAQ_page top img_desktop.jpg": "2646",
	"./QA_Page/FAQ_page top img_mobile.jpg": "a253",
	"./UseCase/coating/Miaoli_01.jpg": "361c",
	"./UseCase/coating/Miaoli_02.jpg": "63b1",
	"./UseCase/coating/Taiwan_01.jpg": "0727",
	"./UseCase/coating/Taiwan_02.jpg": "01c3",
	"./UseCase/coating/Taiwan_03.jpg": "2bb1",
	"./UseCase/coating/Taiwan_04.jpg": "1b46",
	"./UseCase/coating/Yilan_01.jpg": "a432",
	"./UseCase/coating/Yilan_02.jpg": "3e50",
	"./UseCase/coating/reference pics_YFY UASB1.jpg": "c2f7",
	"./UseCase/coating/reference pics_YFY UASB2.jpg": "83ba",
	"./UseCase/coating/reference pics_cgu university1.jpg": "9d1e",
	"./UseCase/coating/reference pics_cgu university2.jpg": "d719",
	"./UseCase/coil/reference pics_AUS pool1.jpg": "1a8c",
	"./UseCase/coil/reference pics_AUS pool2.jpg": "bb13",
	"./UseCase/coil/reference pics_AUS pool3.jpg": "d265",
	"./UseCase/coil/reference pics_Brazil pool.jpg": "b934",
	"./UseCase/coil/reference pics_Sixth Naphtha1.jpg": "94fd",
	"./UseCase/coil/reference pics_Sixth Naphtha2.jpg": "f361",
	"./UseCase/coil/reference pics_USA pool.jpg": "e0fc",
	"./UseCase/coil/reference pics_canada pool.jpg": "a44b",
	"./UseCase/coil/reference pics_cgu university1.jpg": "4881",
	"./UseCase/coil/reference pics_cgu university2.jpg": "0b6f",
	"./UseCase/coil/reference pics_cgu university3.jpg": "6723",
	"./UseCase/coil/reference pics_forth tunnel1.jpg": "c2a9",
	"./UseCase/coil/reference pics_forth tunnel2.jpg": "52d2",
	"./UseCase/coil/reference pics_house1.jpg": "c451",
	"./UseCase/coil/reference pics_house2.jpg": "ede6",
	"./UseCase/coil/reference pics_house3.jpg": "6481",
	"./UseCase/coil/reference pics_hsuehshan tunnel1.jpg": "866a",
	"./UseCase/coil/reference pics_hsuehshan tunnel2.jpg": "bfbe",
	"./UseCase/coil/reference pics_hsuehshan tunnel3.jpg": "26a5",
	"./UseCase/coil/reference pics_redmud chaiyi.jpg": "2e17",
	"./UseCase/coil/reference pics_redmud tainan.jpg": "6179",
	"./UseCase/coil/reference pics_suhua tunnel1.jpg": "5449",
	"./UseCase/coil/reference pics_suhua tunnel2.jpg": "8a71",
	"./UseCase/reference_page top img_desktop.jpg": "204c",
	"./UseCase/reference_page top img_mobile.jpg": "0c56",
	"./banner/banner_desktop0.jpg": "789e",
	"./banner/banner_desktop1.jpg": "99a0",
	"./banner/banner_desktop2.jpg": "13b3",
	"./banner/banner_desktop3.jpg": "88a6",
	"./banner/banner_desktop4.jpg": "f228",
	"./banner/banner_desktop5.jpg": "fc51",
	"./banner/banner_desktop6.jpg": "605d2",
	"./banner/banner_desktop7.jpg": "bd91",
	"./banner/banner_mobile0.jpg": "bab9",
	"./banner/banner_mobile1.jpg": "9841",
	"./banner/banner_mobile2.jpg": "f66c",
	"./banner/banner_mobile3.jpg": "cf4c",
	"./banner/banner_mobile4.jpg": "f969",
	"./banner/banner_mobile5.jpg": "f5dfc",
	"./banner/banner_mobile6.jpg": "98ed",
	"./banner/banner_mobile7.jpg": "2567",
	"./banner/icon01.png": "f75d",
	"./banner/icon02.png": "6810",
	"./code.jpg": "b209",
	"./company/company_history_renwu1979.jpg": "7b02",
	"./company/company_history_renwu1980.jpg": "536d",
	"./company/company_history_renwu2004.jpg": "7081",
	"./company/company_history_renwu2014.jpg": "3ae3",
	"./company/company_history_renwu2019.jpg": "fc63",
	"./company/company_history_renwu2020.jpg": "3a85",
	"./company/company_history_shulin1985.jpg": "d7d2",
	"./company/company_history_shulin2006.jpg": "218b",
	"./company/company_history_shulin2010.jpg": "3bd4",
	"./company/company_history_shulin2018.jpg": "dd5e",
	"./company/company_history_shulin2020.jpg": "250f",
	"./company/company_introduce_1.jpg": "18bb",
	"./company/company_introduce_2.jpg": "eb22",
	"./company/company_pageTop_desktop.jpg": "2fc9",
	"./company/home_page top img_mobile.jpg": "456d",
	"./home/backgroundImg_1.png": "27ae",
	"./home/home_green-enegry.jpg": "edbb",
	"./home/home_productcard_cooler.jpg": "86cb",
	"./home/home_productcard_cooler_mobile.jpg": "f2b4",
	"./home/home_productcard_normal.jpg": "8f37",
	"./home/home_productcard_normal_mobile.jpg": "d84e",
	"./home/home_productcard_pool.jpg": "ce78",
	"./home/home_productcard_pool_mobile.jpg": "c143",
	"./home/home_productcard_pu.jpg": "b13f",
	"./home/home_productcard_pu_mobile.jpg": "8022",
	"./home/home_productcard_redmud.jpg": "6d9c",
	"./home/home_productcard_redmud_mobile.jpg": "638b",
	"./home/home_productcard_roof.jpg": "861e",
	"./home/home_productcard_roof_mobile.jpg": "4481",
	"./home/home_productcard_tunnel.jpg": "ac86",
	"./home/home_productcard_tunnel_mobile.jpg": "0623",
	"./icon01.svg": "828a",
	"./icon01_black.svg": "ad11",
	"./icon02.svg": "aafe",
	"./icon02_black.svg": "4870",
	"./logo.png": "cf05",
	"./logo_white.png": "428c",
	"./nanya-plastics-mall-IMG.png": "a22a",
	"./product_item_bgImg.png": "5066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";